
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pressrelease/page/[id]",
      function () {
        return require("private-next-pages/pressrelease/page/[id].tsx");
      }
    ]);
  